require('../../modules/es6.array.is-array');
module.exports = require('../../modules/_core').Array.isArray;



// WEBPACK FOOTER //
// ../node_modules/@babel/runtime-corejs2/node_modules/core-js/library/fn/array/is-array.js